import { Box, InputAdornment, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { useInputWithDebounce } from 'customHook/useInputWithDebounce';
import zeplinColor from 'theme/Color';
import DropDown from './Dropdown';

const GlobalSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const searchRef = useRef<HTMLDivElement | null>(null);

  const { value, debouncedValue, handleChange, clearInput } = useInputWithDebounce('', 500);

  const handleFocus = () => {
    setIsOpen(true);
  };

  const handleCloseSearch = () => setIsOpen(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box sx={{ flex: 2, position: 'relative' }} ref={searchRef}>
      <Box onClick={handleFocus}>
        <Box
          sx={{
            height: '48px',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          }}
        >
          <TextField
            variant='outlined'
            placeholder='Search'
            value={value}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <img
                    width={20}
                    height={20}
                    src={'/assets/search-icon.svg'}
                    alt='search-project'
                    style={{
                      borderRadius: '14px',
                      objectFit: 'fill',
                      cursor: 'pointer',
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: value ? (
                <InputAdornment position='end' onClick={clearInput}>
                  <img
                    width={20}
                    height={20}
                    src={'/assets/clear-input.svg'}
                    alt='clear-input'
                    style={{
                      borderRadius: '14px',
                      objectFit: 'fill',
                      cursor: 'pointer',
                    }}
                  />
                </InputAdornment>
              ) : (
                ''
              ),
              sx: {
                borderRadius: '50px',
                border: `1px solid ${zeplinColor.Neutral6}`,
                '&.Mui-focused': { border: `1px solid ${zeplinColor.Neutral6}` },
              },
            }}
            sx={{
              width: '100%',
              height: '48px',
              padding: 0,

              '& .MuiInputBase-input': {
                padding: '12px 12px',
              },
            }}
          />
        </Box>
        {isOpen && <DropDown searchValue={debouncedValue} handleCloseSearch={handleCloseSearch} />}
      </Box>
    </Box>
  );
};

export default GlobalSearch;
